import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Mohammed Alyafei</h2>
        <p>
          <a href="mailto:m.saleh.m.360@gmail.com">m.saleh.m.360@gmail.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        This is Mohammed Alyafei, a dedicated Computer Engineering graduate from{' '}
        <a href="https://www.sharjah.ac.ae/">University of Sharjah. </a>
        Specializes in Technology Audit | Governance | Risk Management.< br />
        He ensures systems are secure, efficient, and aligned with organizational objectives.
        Passionate about innovation and excellence.
        Mohammed is committed to helping organizations thrive in the ever-evolving digital landscape.
        <strong> Proud to have been part of the Audit teams at: </strong> <br />
        <a href="https://www.adib.ae/">ADIB {'('}Abu Dhabi Islamic Bank{')'}</a>< br />
        <a href="https://www.eand.com/">e& {'('}etisalat and | Global technology group{')'} </a>< br />
        <a href="https://www.deloitte.com/"> Deloitte </a>
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Mohammed Alyafei <Link to="/">mohammed-profile.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
